import React from 'react';
import cn from 'classnames';

import Laser from './Laser';

const TaskResponseImageClassification = ({ animate, hero }) => (
  <div className="wrapper">
    <Laser animate={animate} />
    <img
      className={cn({ hero })}
      src="/static/img/website/index/examples/image-categorization/example.jpg"
      alt="a t-shit with a dinosaur stamp"
    />
    {hero && (
      <p>
        &quot;image&quot;: [&quot;Dinosaur&quot;]
      </p>
    )}
    <style jsx>{`
      .wrapper {
        background: white;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }
      
      img {
        width: 200px;
        height: auto;
      }
      img.hero {
        width: 70%;
      }
    `}</style>
  </div>
);

TaskResponseImageClassification.defaultProps = {
  animation: false,
  hero: false // for when example is in a hero
};

export default TaskResponseImageClassification;
